import { useContext } from 'react';

import { HistogramTickAxisContext } from '../contexts/HistogramTickAxis.context.js';

export const useHistogramTickAxis = () => useContext(HistogramTickAxisContext);
